module.exports = __webpack_public_path__ + "img/user8.e8037035.jpg";